import { render, staticRenderFns } from "./GroupGridOptions.vue?vue&type=template&id=fa7d8d0a&scoped=true&"
import script from "./GroupGridOptions.vue?vue&type=script&lang=ts&"
export * from "./GroupGridOptions.vue?vue&type=script&lang=ts&"
import style0 from "./GroupGridOptions.vue?vue&type=style&index=0&id=fa7d8d0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7d8d0a",
  null
  
)

export default component.exports